import { ComplexRoleUI } from '../types/interfaces';

export const ComplexRoleTemplate: ComplexRoleUI = {
  id: 0,
  name: '',
  description: '',
  roleUIs: []
};
